export const log = (primaryMessage, ...supportingData) => {
    if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production') {
        console.log(primaryMessage, supportingData);
    }
};
